export enum EditVehiculeTab {
  INFOS = 'infos',
  VEHICULE_CHECKS = 'vehiculeChecks',
}
